module.exports = __webpack_public_path__ + "imgs/hand-card.987ee7b508a09939bcfe41e03b16ef9c.png";